<template>
    <el-container class="Wrapper">
        <el-container class="container">
            <el-main class="">
                <div class="main main2">
                    <div class="screening">
                        <span class="type">促销类别</span>
                        <span class="FilterDox">
                            <el-select v-model="types" placeholder="">
                                <el-option label="代金券" value="1" />
                                <el-option label="满减券" value="2" />
                                <el-option label="折扣券" value="3" />
                                <el-option label="兑换券" value="4" />
                            </el-select>
                        </span>
                        <span class="SearchDox">
                            <span><el-input class="inputbox" v-model="search" placeholder="请输入促销活动名称" /></span>
                            <span><el-button type="primary" @click="xians">查询</el-button></span>
                            <el-button type="primary" @click="toggleModala" class="appear"
                                style="margin-left: 10px;">新增促销活动</el-button>
                        </span>
                    </div>

                    <div class="main1">
                        <div class="main_item1 " style="height: 100%;">
                            <el-table :data="coupons" style="width: 100%;" height="75vh">
                                <el-table-column prop="id" label="序号">
                                    <template v-slot="{ $index }">{{ $index + 1 }}</template>
                                </el-table-column>
                                <el-table-column prop="id" label="券ID"></el-table-column>
                                <el-table-column prop="promotionName" label="优惠券名称" width="100"></el-table-column>
                                <el-table-column prop="" label="优惠类别">
                                    <template #default="{ row }">
                                        <span v-if="row.discountType === 2">满减券</span>
                                        <span v-if="row.discountType === 1">代金券</span>
                                        <span v-if="row.discountType === 3">折扣券</span>
                                        <span v-if="row.discountType === 4">兑换券</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="description" label="描述" width="150"></el-table-column>
                                <el-table-column prop="" label="优惠金额">
                                    <template #default="{ row }">{{ row.discountPrice }}</template>
                                </el-table-column>
                                <el-table-column prop="number" label="数量"></el-table-column>
                                <el-table-column prop="activityStartTime" label="开始时间" width="100"></el-table-column>
                                <el-table-column prop="activityEndTime" label="结束时间" width="100"></el-table-column>
                                <el-table-column label="操作" width="200">
                                    <template #default="scope">
                                        <el-button type="primary" @click="primary(scope.row.id)">编辑</el-button>
                                        <el-button type="danger" @click="deleteCoupon(scope.row.id)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="alluserfoots">
                            <div class="demo-pagination-blocks">
                                <el-pagination class="juzhong" v-model:current-page="currentPage4"
                                    v-model:page-size="pageSize4" @size-change="handleSizeChangese"
                                    @current-change="handleCurrentChangese" :current-page="currentPage4"
                                    :page-sizes="[10, 20, 30, 40]" :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>

                    <div class="PopUps">
                        <div v-if="showModal" class="modal">
                            <div class="modal-content">
                                <span class="close" @click="toggleModal">&times;</span>
                                <span>创建/编辑优惠券</span>
                                <el-form :model="form" label-width="120px">
                                    <el-form-item label="促销活动名称">
                                        <el-input class="inputbox" v-model="form.promotion_name" />
                                    </el-form-item>

                                    <el-form-item label="优惠券类别">
                                        <el-radio-group v-model="form.discount_type">
                                            <el-radio label="代金券" value="1" />
                                            <el-radio label="满减券" value="2" />
                                            <el-radio label="兑换券" value="3" />
                                            <el-radio label="折扣券" value="4" />
                                        </el-radio-group>
                                    </el-form-item>

                                    <el-form-item label="折扣金额">
                                        <el-input class="inputbox" v-model="form.discount_price"
                                            placeholder="请输入(为0时折扣无限制)" />
                                    </el-form-item>

                                    <el-form-item v-if="form.discount_type === '折扣券'" label="使用门槛">
                                        折扣比例<el-input class="inputboxs"
                                            v-model="form.discount_percent" />%，折扣上限<el-input class="inputboxs"
                                            v-model="form.discount_limit_price" />
                                    </el-form-item>

                                    <el-form-item label="优惠券有效天数">
                                        <el-input-number v-model="form.discount_valid" :min="1" />天
                                    </el-form-item>

                                    <el-form-item label="是否限制数量">
                                        <el-radio-group v-model="form.is_number">
                                            <el-radio label="限量" value="1" />
                                            <el-radio label="不限量" value="0" />
                                        </el-radio-group>
                                    </el-form-item>

                                    <el-form-item label="优惠券数量" v-if="form.is_number == '1'">
                                        <el-input-number v-model="form.number" :min="1" />张
                                    </el-form-item>

                                    <el-form-item label="使用范围">
                                        <el-radio-group v-model="form.use_scope" @change="handleScopeChange">
                                            <el-radio label="门店" value="1" />
                                            <el-radio label="类别" value="2" />
                                        </el-radio-group>
                                    </el-form-item>

                                    <!-- 门店选择器 -->
                                    <el-form-item label="门店选择" v-if="form.use_scope === '门店'">
                                        <el-select v-model="form.storeIds" placeholder="请选择商品的门店" multiple clearable
                                            style="width: 300px">
                                            <el-option v-for="item in storeList" :key="item.id"
                                                :label="`${item.name} (ID: ${item.id})`" :value="item.id.toString()" />
                                        </el-select>
                                    </el-form-item>

                                    <!-- 类别选择器 -->
                                    <el-form-item label="类别选择" v-if="form.use_scope === '类别'">
                                        <el-select v-model="form.categoryIds" placeholder="请选择商品的类别" multiple clearable
                                            style="width: 300px">
                                            <el-option v-for="item in categoryList" :key="item.id"
                                                :label="`${item.name} (ID: ${item.id})`" :value="item.id.toString()" />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="条件">
                                        <el-radio-group v-model="form.promotion_condition">
                                            <el-radio label="金额" value="1" />
                                            <el-radio label="订单" value="2" />
                                        </el-radio-group>
                                    </el-form-item>

                                    <el-form-item label="发放条件">
                                        <el-input-number v-model="form.coupon_condition" :min="1" />
                                    </el-form-item>

                                    <el-form-item label="有效期" class="time">
                                        <el-radio label="固定时间" v-model="form.Fixedtime">
                                            日期范围<el-date-picker v-model="form.value2" type="datetimerange"
                                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                                align="right"></el-date-picker>
                                        </el-radio>
                                    </el-form-item>

                                    <el-form-item label="发放类型">
                                        <el-radio-group v-model="form.take_type">
                                            <el-radio label="后台自动发放" value="2" />
                                            <el-radio label="用户自主领取" value="1" />
                                        </el-radio-group>
                                    </el-form-item>

                                    <el-form-item label="促销描述">
                                        <el-input class="inputboxsa" v-model="form.description" placeholder="请描述促销活动" />
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="primary" @click="onSubmit">确定</el-button>
                                        <el-button @click="toggleModal">取消</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>

<script setup>
import axios from "axios";
import { onMounted, ref, toRaw,reactive } from "vue";
import { ElMessage, ElMessageBox } from 'element-plus'
import instance from '../../network/storester.js'
import { useRouter } from 'vue-router'

// 状态与数据定义
const type = ref('')
const types = ref('')
const coupons = ref([]);
const search = ref('')
const couponss = ref(null)
const showModal = ref(false);
const router = useRouter();
const storeList = ref([])  // 门店列表
const categoryList = ref([])  // 类别列表
const pand = ref(true)  // 标记新增/编辑状态

// 表单数据
const form = ref({
    id: '',
    promotion_name: '',
    discount_type: '',
    discount_percent: '',
    discount_limit_price: '',
    discount_price: '',
    discount_valid: 1,
    is_number: '2',  // 默认不限量
    number: 0,
    use_scope: '1',  // 默认门店
    storeIds: [],    // 选中的门店ID数组(字符串类型)
    categoryIds: [], // 选中的类别ID数组(字符串类型)
    promotion_condition: '1',
    coupon_condition: 1,
    Fixedtime: '固定时间',
    value2: [],
    take_type: '2',
    user: '1',
    description: ''
})

// 页面初始化加载数据
onMounted(() => {
    xians()
})
const total = ref(0)
const loading = ref(true)
const page = reactive({ pageNum: 1, pageSize: 10 });
const handleSizeChangese = (val) => {
    page.pageSize = val;
    loading.value = true;
    xians();
};
//当前页改变时触发
const handleCurrentChangese = (val) => {
    page.pageNum = val;
    loading.value = true;
    xians();
};
// 获取基础数据
const xians = () => {
    loading.value = true;
    // 获取类别列表
    instance.get(`/api/categories/getMeanCategories`)
        .then(response => {
            categoryList.value = response.data.data || [];
            // 确保ID为字符串类型
            categoryList.value = categoryList.value.map(item => ({
                ...item,
                id: item.id.toString()
            }));
        })
        .catch(error => {
            ElMessage({ message: '请登录', type: 'error' });
            router.push('./');
        })

    // 获取门店列表
    instance.get(`/api/stores`)
        .then(response => {
            storeList.value = response.data || [];
            // 确保ID为字符串类型
            storeList.value = storeList.value.map(item => ({
                ...item,
                id: item.id.toString()
            }));
        })
        .catch(error => {
            ElMessage({ message: '请登录', type: 'error' });
            router.push('./');
        })
    const data = {
        pageNum: page.pageNum,
        pageSize: page.pageSize,
        promotionName: search.value,
        discountType:Number(types.value)
    }
    // 获取优惠券列表
    instance.post('/api/promotion/list', data)
        .then(response => {
            couponss.value = response.data.data.dataList || [];
            coupons.value = toRaw(couponss.value);
            loading.value = false;
            total.value = response.data.data.total
        }).catch(error => {
            ElMessage({ message: '请重新登录', type: 'error' });
            router.push('./');
        })
}

// 切换使用范围时清空选中项
const handleScopeChange = () => {
    if (form.value.use_scope === '1') {
        form.value.storeIds = [];
    } else {
        form.value.categoryIds = [];
    }
}

// 提交表单
// 提交表单（区分新增/编辑接口）
const onSubmit = () => {
    // 基础校验（保持原有校验逻辑不变）
    if (!form.value.promotion_name) {
        ElMessage({ type: 'error', message: '请输入优惠券名称' });
        return;
    }
    if (!form.value.description) {
        ElMessage({ type: 'error', message: '请输入优惠券描述' });
        return;
    }
    if (form.value.is_number === '1' && (form.value.number <= 0 || !form.value.number)) {
        ElMessage({ type: 'error', message: '请输入有效优惠券数量' });
        return;
    }
    if (!form.value.value2 || form.value.value2.length < 2) {
        ElMessage({ type: 'error', message: '请选择优惠券时间' });
        return;
    }

    // 确定提交的范围ID（保持原有逻辑不变）
    let scopeIds = '';
    if (form.value.use_scope === '1') {
        scopeIds = form.value.storeIds.join(',');
    } else {
        scopeIds = form.value.categoryIds.join(',');
    }

    // 构造提交参数（保持原有参数逻辑不变）
    const params = {
        promotionName: form.value.promotion_name,
        activityStartTime: form.value.value2[0] ? new Date(form.value.value2[0]).toISOString().split('T')[0] : '',
        activityEndTime: form.value.value2[1] ? new Date(form.value.value2[1]).toISOString().split('T')[0] : '',
        useScope: form.value.use_scope === '门店' ? 1 : 2,
        scopeIds: scopeIds,
        promotionCondition: form.value.promotion_condition === '金额' ? 0 : 1,
        couponCondition: Number(form.value.coupon_condition),
        discountPercent: Number(form.value.discount_percent) || 0,
        discountLimitPrice: Number(form.value.discount_limit_price) || 0,
        discountPrice: Number(form.value.discount_price) || 0,
        discountValid: Number(form.value.discount_valid) || 1,
        isNumber: form.value.is_number === '限量' ? 1 : 0,
        number: form.value.is_number === '1' ? Number(form.value.number) : 0,
        is_deleted: 0,
        description: form.value.description,
        discountType: (() => {
            switch (form.value.discount_type) {
                case '代金券': return 1;
                case '满减券': return 2;
                case '折扣券': return 3;
                case '兑换券': return 4;
                default: return ''; // 默认空值
            }
        })(),
        takeType: form.value.take_type === '后台自动发放' ? 2 : 1
    };

    // 编辑时补充ID（编辑接口需传入ID）
    if (!pand.value) {
        params.id = form.value.id;
    }

    // 根据pand.value判断调用新增/编辑接口
    const apiUrl = pand.value
        ? '/api/promotion/save'  // 新增接口（假设新增接口路径）
        : '/api/promotion/update'; // 编辑接口（假设编辑接口路径）

    // 提交请求
    instance.post(apiUrl, params)
        .then(response => {
            // 根据状态显示对应提示
            if (response.data.state === 20000) {
                const message = pand.value ? '新增成功' : '编辑成功';
                ElMessage({ message: message, type: 'success' });
                toggleModal(); // 关闭弹窗
                xians(); // 重新加载列表数据
            } else {
                const message = response.data.msg;
                ElMessage({ message: message, type: 'error' });
            }

        })
        .catch(error => {
            const errorMsg = pand.value ? '新增失败' : '编辑失败';
            ElMessage({ message: `${errorMsg}，请重试`, type: 'error' });
        })
}

// 打开新增弹窗
const toggleModala = () => {
    pand.value = true;
    form.value = {
        ...form.value,
        id: '',
        promotion_name: '',
        storeIds: [],
        categoryIds: [],
        value2: []
    };
    showModal.value = true;
}

// 关闭弹窗
const toggleModal = () => {
    showModal.value = false;
    form.value = ({
        id: '',
        promotion_name: '',
        discount_type: '',
        discount_percent: '',
        discount_limit_price: '',
        discount_price: '',
        discount_valid: 1,
        is_number: '2',  // 默认不限量
        number: 0,
        use_scope: '1',  // 默认门店
        storeIds: [],    // 选中的门店ID数组(字符串类型)
        categoryIds: [], // 选中的类别ID数组(字符串类型)
        promotion_condition: '1',
        coupon_condition: 1,
        Fixedtime: '固定时间',
        value2: [],
        take_type: '2',
        user: '1',
        description: ''
    })
}

// 编辑功能（修复ID回显）
const primary = (id) => {
    pand.value = false;
    showModal.value = true;
    instance.get(`/api/promotion/${id}`)
        .then(response => {
            const data = response.data.data || {};

            // 1. 解析使用范围
            const useScope = String(data.useScope || 1);

            // 2. 解析选中的ID集合并转为字符串数组
            const scopeIds = data.scopeIds || '';
            let idsArray = [];
            if (scopeIds) {
                idsArray = scopeIds.split(',').map(id => id.toString()); // 确保都是字符串类型
            }

            // 3. 回显表单数据
            form.value = {
                id: data.id,
                promotion_name: data.promotionName || '',
                discount_type: (() => {
                    switch (Number(data.discountType)) {
                        case 1: return '代金券';
                        case 2: return '满减券';
                        case 3: return '折扣券';
                        case 4: return '兑换券';
                        default: return ''; // 默认空值
                    }
                })(),
                discount_percent: data.discountPercent || '',
                discount_limit_price: data.discountLimitPrice || '',
                discount_price: data.discountPrice || '',
                discount_valid: data.discountValid || 1,
                is_number: data.isNumber === 1 ? '限量' : '不限量',
                number: data.number || 0,
                use_scope: useScope === '1' ? '门店' : '类别',
                storeIds: useScope === '1' ? idsArray : [],
                categoryIds: useScope === '2' ? idsArray : [],
                promotion_condition: data.promotionCondition === 0 ? '金额' : '订单',
                coupon_condition: data.couponCondition || 1,
                Fixedtime: '固定时间',
                value2: data.activityStartTime && data.activityEndTime
                    ? [new Date(data.activityStartTime), new Date(data.activityEndTime)]
                    : [],
                take_type: data.takeType === '2' ? '后台自动发放' : '用户自主领取',
                description: data.description || ''
            };

            // 4. 验证并修复ID匹配问题
            if (useScope === '1') {
                // 过滤不存在的门店ID
                form.value.storeIds = form.value.storeIds.filter(id =>
                    storeList.value.some(store => store.id === id)
                );
            } else {
                // 过滤不存在的类别ID
                form.value.categoryIds = form.value.categoryIds.filter(id =>
                    categoryList.value.some(cat => cat.id === id)
                );
            }
        })
        .catch(error => {
            ElMessage({ message: '获取编辑数据失败', type: 'error' });
        })
}

// 删除优惠券
const deleteCoupon = (id) => {
    ElMessageBox.confirm('您确定要删除该优惠券吗?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(() => {
        instance.get(`/api/promotion/deleted/${id}`)
            .then(() => {
                ElMessage({ type: 'success', message: '删除成功' });
                xians();
            })
            .catch(() => {
                ElMessage({ type: 'error', message: '删除失败' });
            })
    }).catch(() => {
        ElMessage({ type: 'info', message: '取消删除' });
    })
}

// 搜索功能
const searchs = () => {
    // 搜索逻辑
}
</script>

<style scoped>
/* 保持原有样式不变 */
.main1 {
    display: flex;
    margin-top: 3vh;
    width: 85vw;
    height: 100vh;
}

.main_item1 {
    height: 100vh;
}

.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
    background-color: #fefefe;
    margin: 8% 15% 15% 15%;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    left: 15vw;
}

.close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
}

.close:hover {
    color: #000;
}

.PopUps {
    position: relative;
    top: 20vh;
    left: 15vw;
    width: 85vw;
    height: 90vh;
}

.inputbox {
    width: 15vw;
}

.inputboxs {
    width: 5vw;
    margin: 0 10px;
}

.inputboxsa {
    width: 25vw;
}

.time {
    width: 40vw;
}

.screening .type {
    font-size: 14px;
    margin-right: 1vw;
    margin-left: 2vw;
}

.screening .FilterDox .el-select {
    width: 10vw;
    margin-right: 1vw;
}

.screening .SearchDox {
    margin-left: 2vw;
}
</style>
